<template>
    <div>
        <div class="text-center">
          <div class="loading"><img src="@/assets/images/spinner.svg" width="100" height="100"></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  props: ['action', 'email', 'token'],
  created() {
    switch (this.action) {
      case "auth":
      this.login();
      break;
      case "logout":
      this.logout();
    }
  },
  methods: {
    login() {

      axios({
        url: 'https://enterprise.qa.live.ecommercebrasil.com.br/v1/graphql',
        method: 'post',
        data: {
          query: `
            {
              signin(username: "`+this.email+`", token: "`+this.token+`") {
                jwt
              }
            }
          `
        } 
      }).then(response => {

        if (response.data.errors) {
          this.logout();
        }
        else {
          const userData = VueJwtDecode.decode(response.data.data.signin.jwt);

          this.$ls.set('userData', userData);

          this.$router.push('/minha-agenda');

        }

      });
    },
    logout() {
      this.$ls.remove('userData');

      this.$router.push('/');
    }
  }
}
</script>